var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-wrapper"},[_c('ImageSelect',{attrs:{"options":_vm.imageOptions,"label":"title","track-by":"title","show-labels":false},model:{value:(_vm.imageValue),callback:function ($$v) {_vm.imageValue=$$v},expression:"imageValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }